import { render, staticRenderFns } from "./CustomerShowConfigurationsTab.vue?vue&type=template&id=777b2e13"
import script from "./CustomerShowConfigurationsTab.vue?vue&type=script&lang=ts"
export * from "./CustomerShowConfigurationsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports